<template>
  <component
    :is="ICON_COMPONENTS[props.name]"
    class="prepeers-icon" />
</template>

<script lang="ts" setup>
import type { Component, PropType } from 'vue'
import type { PrePeersIconName, PrePeersIconProps } from '~/types/PrePeersIcon'
import PrePeersIconArrowRight from './PrePeersIconArrowRight.vue'
import PrePeersIconInfo from './PrePeersIconInfo.vue'
import PrePeersIconChevronRight from './PrePeersIconChevronRight.vue'
import PrePeersIconWhatsApp from './PrePeersIconWhatsApp.vue'
import PrePeersIconShare from './PrePeersIconShare.vue'
import PrePeersIconLock from './PrePeersIconLock.vue'
import PrePeersIconCheck from './PrePeersIconCheck.vue'
import PrePeersIconEye from './PrePeersIconEye.vue'
import PrePeersIconChat from './PrePeersIconChat.vue'
import PrePeersIconGraduation from './PrePeersIconGraduation.vue'
import PrePeersIconMail from './PrePeersIconMail.vue'
import PrePeersIconMessage from './PrePeersIconMessage.vue'
import PrePeersIconCopy from './PrePeersIconCopy.vue'
import PrePeersIconBriefcase from './PrePeersIconBriefcase.vue'
import PrePeersIconSparkles from './PrePeersIconSparkles.vue'
import PrePeersIconAlertTriangle from './PrePeersIconAlertTriangle.vue'
import PrePeersIconInstagram from './PrePeersIconInstagram.vue'
import PrePeersIconTikTok from './PrePeersIconTikTok.vue'
import PrePeersIconSnapchat from './PrePeersIconSnapchat.vue'
import PrePeersIconClose from './PrePeersIconClose.vue'
import PrePeersIconArrowLeft from './PrePeersIconArrowLeft.vue'
import PrePeersIconArrowUp from './PrePeersIconArrowUp.vue'
import PrePeersIconArrowDown from './PrePeersIconArrowDown.vue'
import PrePeersIconChevronDown from './PrePeersIconChevronDown.vue'
import PrePeersIconCalendar from './PrePeersIconCalendar.vue'
import PrePeersIconPlay from './PrePeersIconPlay.vue'
import PrePeersIconTrash from './PrePeersIconTrash.vue'

/**
 * Rend le glyphe SVG correspondant à `name` (icônes template-only du dossier icons/).
 */
const props: PrePeersIconProps = defineProps({
  name: {
    type: String as PropType<PrePeersIconName>,
    required: true,
  },
})

const ICON_COMPONENTS: Record<PrePeersIconName, Component> = {
  'arrow-right': PrePeersIconArrowRight,
  info: PrePeersIconInfo,
  'chevron-right': PrePeersIconChevronRight,
  whatsapp: PrePeersIconWhatsApp,
  share: PrePeersIconShare,
  lock: PrePeersIconLock,
  check: PrePeersIconCheck,
  eye: PrePeersIconEye,
  chat: PrePeersIconChat,
  graduation: PrePeersIconGraduation,
  mail: PrePeersIconMail,
  message: PrePeersIconMessage,
  copy: PrePeersIconCopy,
  briefcase: PrePeersIconBriefcase,
  sparkles: PrePeersIconSparkles,
  'alert-triangle': PrePeersIconAlertTriangle,
  instagram: PrePeersIconInstagram,
  tiktok: PrePeersIconTikTok,
  snapchat: PrePeersIconSnapchat,
  close: PrePeersIconClose,
  'arrow-left': PrePeersIconArrowLeft,
  'arrow-up': PrePeersIconArrowUp,
  'arrow-down': PrePeersIconArrowDown,
  'chevron-down': PrePeersIconChevronDown,
  calendar: PrePeersIconCalendar,
  play: PrePeersIconPlay,
  trash: PrePeersIconTrash,
}
</script>
